import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { formatStaffName } from "@/lib/format-data";
export interface SelfScheduleUrlPrefillRequest {
  providerId: string | null;
  locationId: string | null;
}
interface PrefillLookupData {
  providers: Array<{
    id: string;
    firstName?: string;
    lastName?: string;
  }>;
  locations: Array<{
    id: string;
    name: string;
  }>;
}
const getMessage = ({
  providerName,
  locationName
}: {
  providerName?: string;
  locationName?: string;
}) => {
  if (providerName && locationName) {
    return `You're booking with ${providerName} at ${locationName}.`;
  }
  if (providerName) return `You're booking with ${providerName}.`;
  if (locationName) return `You're booking at ${locationName}.`;
  return null;
};

/**
 * Builds the narrow view model used by the booking-link context banner.
 * Requested dimensions remain active after URL cleanup, while their displayed
 * values follow the patient's current provider and location selections.
 */
export const useSelfScheduleUrlPrefill = t0 => {
  const $ = _c(12);
  const {
    requestedContext,
    selectedProviderId,
    selectedLocationId,
    frontPageData,
    isLoading,
    isResolved
  } = t0;
  let t1;
  bb0: {
    const hasRequestedContext = Boolean(requestedContext.providerId || requestedContext.locationId);
    if (!hasRequestedContext) {
      t1 = null;
      break bb0;
    }
    if (isLoading || !isResolved) {
      t1 = "Loading your booking link\u2026";
      break bb0;
    }
    if (!frontPageData) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[0] !== frontPageData || $[1] !== requestedContext.providerId) {
      t2 = requestedContext.providerId && frontPageData.providers.some(t3 => {
        const {
          id
        } = t3;
        return id === requestedContext.providerId;
      });
      $[0] = frontPageData;
      $[1] = requestedContext.providerId;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const hasValidRequestedProvider = Boolean(t2);
    let t3;
    if ($[3] !== frontPageData || $[4] !== requestedContext.locationId) {
      t3 = requestedContext.locationId && frontPageData.locations.some(t4 => {
        const {
          id: id_0
        } = t4;
        return id_0 === requestedContext.locationId;
      });
      $[3] = frontPageData;
      $[4] = requestedContext.locationId;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const hasValidRequestedLocation = Boolean(t3);
    let t4;
    if ($[6] !== frontPageData || $[7] !== hasValidRequestedLocation || $[8] !== hasValidRequestedProvider || $[9] !== selectedLocationId || $[10] !== selectedProviderId) {
      const provider = hasValidRequestedProvider ? frontPageData.providers.find(t5 => {
        const {
          id: id_1
        } = t5;
        return id_1 === selectedProviderId;
      }) : undefined;
      const location = hasValidRequestedLocation ? frontPageData.locations.find(t6 => {
        const {
          id: id_2
        } = t6;
        return id_2 === selectedLocationId;
      }) : undefined;
      t4 = getMessage({
        providerName: provider ? formatStaffName(provider) : undefined,
        locationName: location?.name
      });
      $[6] = frontPageData;
      $[7] = hasValidRequestedLocation;
      $[8] = hasValidRequestedProvider;
      $[9] = selectedLocationId;
      $[10] = selectedProviderId;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t1 = t4;
  }
  return t1;
};